import React, { useState, useEffect } from "react";
import {
    Typography, Grid, InputBase, Button,
} from "@material-ui/core";
import { Dropdown, Menu } from "antd";
import Detail from "../../../../../assets/img/common/details.svg";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ClearIcon from "@material-ui/icons/Clear";
import { SearchOutlined as SearchIcon } from "@material-ui/icons";
import AddDocument from "../proposalDocuments/components/AddDocument";
import { PostDataAPI } from '../../../../../Services/APIService';
import DeleteNoSpace from "./../../../../../assets/img/icons/DeleteNoSpace.svg";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../components/Message/Alert";
import DocumentSVG from "../../../../../assets/img/documentSVG.svg";
import PreviewDoc from '../../../../../assets/img/icons/eye.svg';
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import NoRecord from "../../../../../components/NoRecord/NoRecord";

const CustomCard = ({ programData, ...props }) => {
    const [data, setData] = useState([]);
    const classes = useStyles();
    const [addNewAddressDialog, setAddNewAddressDialog] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState('');
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });





    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };

    const closeAddAddress = () => {
        setAddNewAddressDialog(false);
        setEditData('');
        setIsEdit(null);
    };

    const handleSuccessClose = (message) => {
        setEditItem({});
        // closeAddNotes();
        closeAddAddress();
        showMessage("Success", message, "success", 3000);
        //   loadDocuments()
    }

    const programModal = () => {
        setAddNewAddressDialog(true);
    };

    const loadAddressBookGrid = () => {
        PostDataAPI("fdngrantprograms/loadGrid").then((result) => {
            console.log(result);
            if (result.success && result.data != null) {
                setData(
                    result.data.map((item) => {
                        item.name = item.name;
                        return { ...item };
                    })
                );
            } else {
                setData([]);
            }
        });
    };
    //=============================================================================

    // --------------- Search Grid
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    const [dcData, setDcData] = useState([]);

    const loadDocuments = () => {

        let obj = {
            disbursementId: null,
            collectionId: null,
            donorId: null,
            programId: programData?.programId,
            Type: "Program Documentation",
            Category: "Program",
        }

        PostDataAPI("fdngrantattachments/loadGrid", obj).then((result) => {
            if (result.success && result.data != null) {
                setDcData(result.data)
            } else {
                setData([]);
            }
        });
    }

    useEffect(() => {
        loadDocuments()
    }, 100)



    // Mapping of types to headings
    const typeHeadings = {
        internal: 'Proposal Documents',
        external: 'Strategic Plans',
    };

    const handleDownload = (url) => {
        try {
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", ""); // browser keeps original filename
            link.target = "_blank";            // optional
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download failed:", error);
        }
    };



    const deleteDocument = (item) => {

        let obj = {
            attachmentId: item.attachmentId,
        }
        showActionDialog(
            "Are you sure you want to delete this document?",
            "confirm",
            function () {
                PostDataAPI("fdngrantattachments/delete", obj).then((result) => {

                    if (result.success && result.data != null) {
                        showMessage("Success", "Document has been deleted successfully", "success", 3000);
                        loadDocuments()
                    } else {
                        showMessage("error", result.message, "success", 3000);

                    }
                });
            }
        );

    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const handleClearInput = (name) => {
        setSearchQuery('')
    };
    //=======================================================================
    useEffect(() => {
        loadAddressBookGrid();
    }, []);



    return (
        <>

            <Grid container className={classes.gridHeader}>

                <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn} onClick={() => programModal()}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add Document
                        </Button>
                    </div>

                    <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                        {/* <InputBase
                            placeholder="Search"
                            className="grid-search-input"
                            endAdornment={searchQuery ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                            startAdornment={<SearchIcon />}
                            value={searchQuery}
                            onChange={handleSearchChange}
                        /> */}
                    </div>
                </div>
            </Grid>


            {Object.entries(typeHeadings).map(([type, heading]) => {
                const filteredData = dcData.filter((item) => item.subType === heading);

                // Render section only if there is data for the current type
                if (dcData.length > 0) {
                    return (
                        <div key={type} className={classes.DocMainDiv}>
                            <Typography variant="h3" className={classes.DocumentsHeading}>{heading}</Typography>
                            <Grid container spacing={2}>
                                {filteredData.map((item) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={2}
                                        key={item.id}
                                        className={classes.CardGrid}
                                    >
                                        <div className={classes.Card}>
                                            <Dropdown
                                                overlay={
                                                    <Menu>

                                                        <Menu.Item className={classes.DropdownItems}>
                                                            <a
                                                                onClick={() => {
                                                                    deleteDocument(item);
                                                                }}
                                                            >
                                                                <img
                                                                    className={classes.profileNavigationIco}
                                                                    src={DeleteNoSpace}
                                                                />{" "}
                                                                Delete
                                                            </a>
                                                        </Menu.Item>
                                                    </Menu>
                                                }
                                                trigger={["click"]}
                                                className={classes.actionDropDown}
                                            >
                                                <Button className={`DetailLogo ${classes.profileDropper}`}>
                                                    <img src={Detail} alt="Detail" />
                                                </Button>
                                            </Dropdown>
                                            <div className={"CardBanner"}>
                                                {/* Your banner image */}
                                                <img className={"BannerImg"} src={DocumentSVG} alt="Banner" />
                                            </div>
                                            <div className={"CardMain"}>
                                                <Typography variant="h4" className={"CardHeading"}>
                                                    {item.fileName}
                                                </Typography>
                                                <Button
                                                    className={classes.changeBtnPosition}
                                                    onClick={() => handleDownload(item.filePath)}
                                                >
                                                    Download
                                                </Button>
                                            </div>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    );
                } else {
                    <NoRecord Icon={true}></NoRecord>
                }
            })}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
            {addNewAddressDialog ? (
                <AddDocument
                    dialogOpenClose={programModal}
                    handleClose={closeAddAddress}
                    handleSuccessClose={handleSuccessClose}
                    editProgram={editData} // Conditionally pass EditProgram
                    programData={programData}
                ></AddDocument>
            ) : (
                ""
            )}
        </>
    );
};

export default withSnackbar(CustomCard);
